import React from 'react';
import classnames from 'classnames';
import EmptyBackground from '../EmptyBackground';
import { useDeviationViewContext } from '../../../Context';
import s from './Literature.scss';
export var LiteratureStageBackground = function () {
    var isFullscreen = useDeviationViewContext().isFullscreen;
    return (React.createElement(EmptyBackground, { className: classnames(!isFullscreen && s['background']) }));
};
LiteratureStageBackground.displayName = 'LiteratureStageBackground';
export default LiteratureStageBackground;
//# sourceMappingURL=Literature.js.map